import loadable from '@loadable/component';

const components: { [key: string]: any } = {
  AboutAirline: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/AboutAirline'),
  ),
  Advice: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Advice/Advice'),
  ),
  ArchivePageTitle: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ArchivePageTitle'),
  ),
  ArticleCard: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ArticleCard'),
  ),
  ArticleGrid: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ArticleGrid'),
  ),
  HighlightedArticles: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HighlightedArticles'),
  ),
  EditorialCrossLink: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/EditorialCrossLink'),
  ),
  Breadcrumbs: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Breadcrumbs'),
  ),
  BestTimeToVisitMonthPicker: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/BestTimeToVisitMonthPicker'),
  ),
  Button: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Button'),
  ),
  CardSet: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CardSet'),
  ),
  CheapestTimeTo: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CheapestTimeTo'),
  ),
  CityImageGallery: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DestinationHubPages/CityImageGallery'),
  ),
  ImageGallery: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ImageGallery/ImageGallery'),
  ),
  ConfidenceMessaging: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ConfidenceMessaging'),
  ),
  PackagesConfidenceMessaging: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/PackagesConfidenceMessaging'),
  ),
  ContentBlock: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ContentBlock'),
  ),
  ContentBlockWithImage: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ContentBlockWithImage'),
  ),
  CtaCardSet: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CtaCardSet'),
  ),
  DealsEvolvedWrapper: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DealsEvolved/DealsEvolvedWrapper'),
  ),
  DestinationsExplorer: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DestinationsExplorer'),
  ),
  RelevantRoutesLinks: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/RelevantRoutesLinks'),
  ),
  Faqs: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Faqs'),
  ),
  FlightPricesDisclaimerText: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/FlightPricesDisclaimerText'),
  ),
  FlightsToNearbyAlternatives: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/FlightsToNearbyAlternatives'),
  ),
  HighlightsList: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DestinationHubPages/HighlightsList'),
  ),
  InfoComponent: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DestinationHubPages/InfoComponent'),
  ),
  MobileLanding: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/MobileLanding'),
  ),
  NearbyAirports: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/NearbyAirports'),
  ),
  OppositeLegLink: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/OppositeLegLink'),
  ),
  Separator: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Separator'),
  ),
  SitemapLinksBlock: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SitemapLinksBlock'),
  ),
  SitemapNavigation: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SitemapNavigation'),
  ),
  SitemapPagination: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SitemapPagination'),
  ),
  ArrivalsDeparturesBoard: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ArrivalsDeparturesBoard'),
  ),
  ArrivalsDeparturesCrossLinks: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ArrivalsDeparturesCrossLinks'),
  ),
  Author: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Author'),
  ),
  IndexBlockPanel: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/IndexBlockPanel/IndexBlockPanel'),
  ),
  IndexBlockPlanPeacePanel: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/IndexBlockPlanPeacePanel'),
  ),
  RichText: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/RichText'),
  ),
  RichTextButton: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/RichTextButton'),
  ),
  RichTextAnchor: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/RichTextAnchor'),
  ),
  RichTextTables: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/RichTextTables'),
  ),
  PageHeader: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/PageHeader'),
  ),
  HotelAboutSearchResultsBannerV2: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsIndicativePricesLegalDisclaimer'),
  ),
  HotelsIndicativePricesLegalDisclaimer: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsIndicativePricesLegalDisclaimer'),
  ),
  HotelSearchResultsWrapper: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelSearchResultsWrapper'),
  ),
  HotelSearchResultsWrapperUnified: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelSearchResultsWrapperUnified'),
  ),
  ProviderLogos: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ProviderLogos'),
  ),
  MapPreview: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/MapPreview'),
  ),
  MapFastFacts: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/MapFastFacts'),
  ),
  HotelSearchControlsWrapper: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SearchControlsWrapper'),
  ),
  HotelsByStarRating: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsByStarRating'),
  ),
  Image: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Image'),
  ),
  InfoSnippetDecoupled: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/InfoSnippetDecoupled'),
  ),
  HotelSortingLinks: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SortingLinks'),
  ),
  SeoCrossLinksV2: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SeoCrossLinksV2/CrossLinks/CrossLinks'),
  ),
  InternalLinksGC: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/InternalLinksGC'),
  ),
  CardDeals: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CardDeals'),
  ),
  DynamicMap: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DynamicMap'),
  ),

  SeoBanner: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SeoBanner'),
  ),
  HotelsWithHighestGuestRating: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsWithHighestGuestRating'),
  ),
  HotelsWithHighestGuestRatingSecond: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsWithHighestGuestRating'),
  ),

  HotelsWithClosestDistance: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsWithClosestDistance'),
  ),

  HotelsWithCheapestPrice: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsWithCheapestPrice'),
  ),

  GraphicPromotion: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/GraphicPromotion'),
  ),
  MultiImageBanner: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/MultiImageBanner'),
  ),
  ProviderRating: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ProviderRating'),
  ),
  ProviderRatingBig: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ProviderRatingBig'),
  ),
  PopularDestinations: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/PopularDestinations'),
  ),
  NearbyPickUpLocations: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/NearbyPickUpLocations'),
  ),
  VisualData: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/VisualData'),
  ),
  PopularAirports: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/PopularDestinations'),
  ),
  SearchControlsWrapper: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SearchControlsWrapper'),
  ),
  HorizontalNavigation: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HorizontalNavigation'),
  ),
  SponsoredDestinationExplorer: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SponsoredDestinationExplorer'),
  ),
  SponsoredAirlineExplorer: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SponsoredAirlineExplorer'),
  ),
  HotelsNearPOIsInLocationCards: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelsNearPOIsInLocationCards'),
  ),
  Footer: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Footer'),
  ),
  FooterFlags: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/FooterFlags'),
  ),
  JobsApp: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/JobsApp'),
  ),
  Staycation: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Staycation'),
  ),
  CityBreaks: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CityBreaks'),
  ),
  NoDeals: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/NoDeals'),
  ),
  WordPressArticle: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/WordPressArticle'),
  ),
  DestinationInformation: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/InfoSnippetDecoupled'),
  ),
  DrivingInCity: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DrivingInCity'),
  ),
  CustomNav: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CustomNav'),
  ),
  GoogleOneTap: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/GoogleOneTap'),
    {
      ssr: false,
    },
  ),
  ImageSnippet: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ImageSnippet'),
  ),
  CreatorHeroSection: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CreatorHeroSection'),
  ),
  MyTravelTips: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/MyTravelTips'),
  ),
  VideoEmbedRail: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/VideoEmbedRail'),
  ),
  SnippetEditorial: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/SnippetEditorial'),
  ),
  Accordion: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Accordion'),
  ),
  InfoPanel: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/InfoPanel'),
  ),
  CookieBanner: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CookieBanner'),
  ),
  NotFound: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/NotFound'),
  ),
  ImageSnippetList: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ImageSnippetList'),
  ),
  Text: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Text'),
  ),
  InteractiveMap: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/InteractiveMap'),
  ),
  WebToApp: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/WebToApp'),
    {
      ssr: false,
    },
  ),
  FilterLinks: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/FilterLinks'),
  ),
  Header: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/Header'),
  ),
  TrustpilotReviews: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/TrustpilotReviews'),
  ),
  PackageSearchResults: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/PackageSearchResults'),
  ),
  PackagesPopularDestinations: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/PackagesPopularDestinations'),
  ),
  PackagesCards: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/PackagesCards'),
  ),
  BestTimeToBook: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/BestTimeToBook'),
  ),
  ComparisonCards: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/ComparisonCards'),
  ),
  EditorialCardRail: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/EditorialCardRail'),
  ),
  DestinationInfoCards: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DestinationInfoCards'),
  ),
  DestinationInfoComponent: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DestinationInfoComponent'),
  ),
  Drops: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/DropsWrapper'),
  ),
  FlightStatusDetails: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/FlightStatusDetails'),
  ),
  FlightTrackerSearchControls: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/FlightTrackerSearchControls'),
  ),
  HotelTopRegions: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CityBreaks'),
  ),
  HotelTopCities: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CityBreaks'),
  ),
  HotelTopLandmarks: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/CityBreaks'),
  ),
  HotelTopCitiesWithTravellerTypes: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelTopCitiesWithFilter/HotelTopCitiesWithFilter'),
  ),
  HotelTopCitiesWithAccommodationTypes: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelTopCitiesWithFilter/HotelTopCitiesWithFilter'),
  ),
  HotelTopCitiesWithAmenityTypes: loadable(
    () =>
      import('@skyscanner-internal/landing-pages-shared-ui/src/components/HotelTopCitiesWithFilter/HotelTopCitiesWithFilter'),
  ),
};

export default components;
